import React from 'react';

import { Switch, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import PaymentMethod from 'components/payment-method';
import { useQuickPayState } from 'pages/loyalty/loyalty-in-restaurant-redemption/hooks/use-quickpay-state';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import {
  Container,
  LeftContainer,
  NewText,
  PayWithEase,
  PaymentContainer,
  QuickPay,
  RightContainer,
  SwitchContainer,
} from './loyalty-quick-pay-widget.styled';

const LoyaltyQuickPayWidget = () => {
  const enableIdAndPay = useFlag(LaunchDarklyFlag.ENABLE_ID_AND_PAY_FE);
  const { formatMessage } = useIntl();

  const {
    isAddNewCardMethodSelected,
    setShowAddPaymentMethod,
    isAddGiftCardMethodSelected,
    setIsAddGiftCardMethodSelected,
    availablePaymentMethods,
    isOrbital,
    setIsQuickPayMethodSelected,
    isQuickPayEnabled,
    selectedMethod,
    loading,
    isQuickPayAvailable,
    handleToggle,
    handleSelection,
  } = useQuickPayState();

  if (!enableIdAndPay) {
    return null;
  }

  return (
    <Container>
      <SwitchContainer>
        <LeftContainer>
          <NewText>{formatMessage({ id: 'newExclame' })}</NewText>
          <QuickPay>{formatMessage({ id: 'quickPay' })}</QuickPay>
        </LeftContainer>
        <RightContainer>
          {!loading && (
            <Switch
              aria-label={formatMessage({ id: 'quickPay' })}
              disabled={!isQuickPayAvailable}
              value={isQuickPayEnabled}
              onToggle={handleToggle}
              offTrackColor={primitive.$blackOpacity50}
              onTrackColor={primitive.bk.$crunchyGreen}
            />
          )}
        </RightContainer>
      </SwitchContainer>
      <PayWithEase>
        <Text>{formatMessage({ id: 'payWithEase' })}</Text>
      </PayWithEase>
      <PaymentContainer>
        <PaymentMethod
          aria-expanded="true"
          methods={availablePaymentMethods}
          selectedMethodId={selectedMethod || ''}
          handleSelect={handleSelection}
          isAddCardOpen={isAddNewCardMethodSelected}
          openAddCardOnPress={setShowAddPaymentMethod}
          isAddGiftCardMethodSelected={isAddGiftCardMethodSelected}
          setIsAddGiftCardMethodSelected={setIsAddGiftCardMethodSelected}
          isOrbitalPaymentEnabled={isOrbital}
          isQuickPay
          setIsQuickPayMethodSelected={setIsQuickPayMethodSelected}
        />
      </PaymentContainer>
    </Container>
  );
};

export default LoyaltyQuickPayWidget;
